<template>
  <div id="app">
    <v-app>
      <router-view></router-view>
      <vue-progress-bar></vue-progress-bar>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    this.$Progress.start();
  },
  created () {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },
};
</script>

<style>
.theme--light.application {
    background: #eef7fe;
}
.loadingArea {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translateY(-50%) translateX(-50%) !important;
  -webkit-transform: translateY(-50%) translateX(-50%) !important;
}
.overlay {
  background: rgba(255, 255, 255, 0.8) !important;
  position: absolute !important;
  top:0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 900 !important;
  transition: all 0.5s ease !important;
}
.app-tabs {
  background-color: #2f353a;
  z-index: 999;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
}
.centre {
  background: url('/assets/img/logo.png') top center / 120px no-repeat;
}
/* #app .v-btn,
#app .v-card:not(.v-sheet--tile):not(.v-card--shaped),
#app .v-sheet, .v-sheet--tile {
  border-radius: 2px;
} */
</style>
